/**
 * Which of the active company's platform logos the signed-in shell shows.
 *
 * The only branded surface is the sidebar rail; the logo follows the
 * sidebar's own light/dark surface (not the page theme). The email logo is
 * for the mailers and never reaches the shell. Pure so it can be unit-tested
 * without the shell.
 */

import type { Company } from '../services/api/auth';

export type SidebarSurface = 'light' | 'dark';

export interface ResolvedCompanyBrand {
  /** Platform logo for the sidebar rail. null → render the LognAI mark. */
  mark: string | null;
  /** A company logo is in use → show the "Powered by LognAI" attribution. */
  active: boolean;
}

const present = (url: string | undefined): string | null => (url ? url : null);

export function resolveCompanyBrand(
  company: Pick<Company, 'branding'> | null | undefined,
  surface: SidebarSurface
): ResolvedCompanyBrand {
  const branding = company?.branding;
  if (!branding) return { mark: null, active: false };

  const light = present(branding.platformLight);
  const dark = present(branding.platformDark);
  // Prefer the logo made for this surface; a company that uploaded only one
  // still gets it on both rather than nothing.
  const mark = surface === 'dark' ? dark ?? light : light ?? dark;

  return { mark, active: mark !== null };
}
